export default __webpack_public_path__ + "static/media/onboarding-error-bg.3d90ba04.png";